import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();
export const getBankByIdApi = async (url: string, id: string): Promise<any> => {
  const token = cookies.get('authToken');
  try {
    const response = await axios.get(
      `${url}/bank/getById`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        Id: id
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const addBankApi = async (
  name: string,
  branch: string,
  ifsccode: string,
  accountnumber: string,
  PurposeId: string,
  isEzpay: boolean,
  url: string
) => {
  const token = cookies.get('authToken');
  try {
    const response = await axios.post(
      `${url}/bank/create`, {
      name,
      branch,
      ifsccode,
      accountnumber,
      DonationPurposeId: PurposeId,
      isEzpay: isEzpay
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    )
    return response.data;
  } catch (error) {
    console.error('API Error', error);
    throw error
  }
}

export const updateBankApi = async (
  Id: string,
  Name: string,
  Branch: string,
  IFSCCode: string,
  AccountNumber: string,
  PurposeId: string,
  isEzpay: boolean,
  url: string
) => {
  const token = cookies.get('authToken');
  try {
    const response = await axios.post(
      `${url}/bank/update`, {
      Id,
      Name,
      Branch,
      IFSCCode,
      AccountNumber,
      DonationPurposeId: PurposeId,
      isEzpay: isEzpay
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    )
    return response.data
  } catch (error) {
    console.error('API Error', error);
    throw error
  }
}


export const getAllBankApi = async (url: string): Promise<any> => {
  const token = cookies.get('authToken');
  try {
    const response = await axios.get(`${url}/bank/getallbank`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};